import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const CuratedChart: React.FunctionComponent = ({ }) => {
    const [groupBy, setGroupBy] = React.useState<string | undefined>('downloads')
    const toolbarItems = GroupByType([{ val: 'downloads', display: 'Downloads' }, { val: 'streams', display: 'Streams' }], groupBy, (selected) => {
        setGroupBy(selected)
    }, false)

    return (
        <BPMChart title='Top Curated Sets' subTitle={'By ' + (groupBy == 'downloads' ? 'Downloads' : 'Streams')} type='bar'
            key={groupBy}
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`curated/${groupBy}/byGroup`, options, signal)
            }} additionalParams={{ groupBy: 'name' }} toolBarItems={() => toolbarItems}
            visualRangeEnd={10}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: groupBy == 'downloads' ? 'Downloads' : 'Streams', valueField: 'count', argumentField: 'name',
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Curated/charts/CuratedChart.tsx